"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIREBASE_CONTENT_ADMIN_GROUP_NAME = exports.COGNITO_CONTENT_ADMIN_GROUP_NAME = void 0;
exports.COGNITO_CONTENT_ADMIN_GROUP_NAME = 'content-admin';
exports.FIREBASE_CONTENT_ADMIN_GROUP_NAME = 'contentAdmin';
//# sourceMappingURL=permissionsGroupNames.js.map